module.exports = __webpack_public_path__ + "static/media/25_potolok_2.71_0.3a6684fc.png";